






import { Component, Vue } from 'vue-property-decorator';
import CardMenu from '../components/CardMenu.vue';
import { CardMenuItem } from '../interfaces/card-menu.interface';
import TranslationApiAgent from '../services/translation-api-agent';
import BbParserService from '../services/bb-parser.service';
import GalleryApiAgent from '@/services/gallery-api-agent';

// @ts-ignore
@Component({
  components: {
		'card-menu': CardMenu
	}
})
export default class GalleryRoot extends Vue {

  private galleries: CardMenuItem[] = [];

  constructor(
    private galleryApiAgent = GalleryApiAgent,
    private translationApiAgent = TranslationApiAgent) {
    super();
  }

  mounted() {
    this.galleryApiAgent.getAll().then(result => {
      result.forEach(gallery => {
        this.galleries.push({
          route: '/gallery/' + gallery,
          title: gallery
        });
      });
    });
  }

}

